/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const template = require('./preview.tpl');
module.exports = {
	name: "preview",
	template
}



// WEBPACK FOOTER //
// ./src/appBackend/components/page/preview/preview.js